import React from 'react';

export const columns = [
  {
    title: 'Kategori',
    dataIndex: 'category',
    width: '25%',
    key: 'category',
  },
  {
    title: 'Detail',
    dataIndex: 'detail',
    width: '60%',
    key: 'detail',
  },
  {
    title: 'Sumber',
    dataIndex: 'sumber',
    width: '15%',
    key: 'sumber',
  },
];

export const getTermsData = (onOpenPdf) => [
  {
    key: '1',
    category: <span className="font-semibold">Keaktifan Polis</span>,
    detail: (
      <div className="flex flex-col gap-2">
        <span>
          Polis aktif dengan periode pertanggungan 1 Januari 2025 – 31 Desember
          2025 dan dapat diperpanjang sesuai ketentuan perpanjangan otomatis
          tahunan.
        </span>
      </div>
    ),
    sumber: (
      <span className="text-blue-500 cursor-pointer" onClick={onOpenPdf}>
        policy_agreement.pdf (Halaman 4)
      </span>
    ),
  },
  {
    key: '2',
    category: <span className="font-semibold">Masa Kontestasi</span>,
    detail: (
      <div className="flex flex-col gap-2">
        <span>
          Masa kontestasi berlaku selama 2 tahun sejak tanggal efektif polis.
          Setelah periode ini, klaim tidak dapat ditolak karena alasan
          prapenyakit kecuali ada indikasi penipuan.
        </span>
      </div>
    ),
    sumber: (
      <span className="text-blue-500 cursor-pointer" onClick={onOpenPdf}>
        policy_agreement.pdf (Halaman 14)
      </span>
    ),
  },
  {
    key: '3',
    category: <span className="font-semibold">Masa Tunggu</span>,
    detail: (
      <div className="flex flex-col gap-2">
        <span>
          Masa tunggu 30 hari untuk semua penyakit umum, 12 bulan untuk kondisi
          khusus seperti penyakit jantung dan kanker, dan tidak berlaku untuk
          kecelakaan.
        </span>
      </div>
    ),
    sumber: (
      <span className="text-blue-500 cursor-pointer" onClick={onOpenPdf}>
        policy_agreement.pdf (Halaman 19)
      </span>
    ),
  },
  {
    key: '4',
    category: <span className="font-semibold">Wilayah Klaim</span>,
    detail: (
      <div className="flex flex-col gap-2">
        <span>
          Cakupan wilayah pertanggungan meliputi seluruh Asia kecuali Singapura,
          Jepang, dan Hong Kong.
        </span>
      </div>
    ),
    sumber: (
      <span className="text-blue-500 cursor-pointer" onClick={onOpenPdf}>
        policy_agreement.pdf (Halaman 16)
      </span>
    ),
  },
  {
    key: '5',
    category: <span className="font-semibold">Pengecualian Penyakit</span>,
    detail: (
      <>
        <div className="w-full grid gap-2">
          <p className="text-sm">
            1. Penyakit tertentu dalam 10 bulan pertama (termasuk komplikasi)
            seperti katarak, gangguan tonsil/adenoid/sinus, penyakit tiroid,
            asma/PPOK, TBC, penyakit jantung & pembuluh darah, stroke,
            hipertensi, hepatitis/sirosis, gangguan kandung empedu, diabetes,
            tukak lambung/usus, gangguan saluran kemih, kelainan sistem
            reproduksi (varikokel, endometriosis, miom), hernia/HNP, wasir,
            fistula, epilepsi, tumor jinak/kista.
          </p>
          <p className="text-sm">
            2. Bunuh diri atau melukai diri, serta tindakan melanggar hukum.
          </p>
          <p className="text-sm">
            3. Kanker yang terdiagnosis/diobati dalam 90 hari pertama sejak
            polis berlaku.
          </p>
          <p className="text-sm">
            4. Penyakit/cedera akibat perang, terorisme, huru-hara, pemogokan,
            pemberontakan, atau tugas militer.
          </p>
          5. Perawatan gigi bukan karena kecelakaan, termasuk kosmetik,
          ortodonti, pemutihan.
          <p className="text-sm">
            6. Pemeriksaan mata & operasi refraksi untuk kacamata/koreksi
            penglihatan.
          </p>
          <p className="text-sm">
            7. Kehamilan, persalinan, keguguran, kontrasepsi, infertilitas.
          </p>
          <p className="text-sm">8. Disfungsi seksual, sterilisasi.</p>
          <p className="text-sm">
            9. Kondisi bayi baru lahir {'<'}2 tahun & cacat bawaan (kecuali
            pasca-trauma).
          </p>
          <p className="text-sm">
            10. Operasi plastik/kosmetik, perawatan penurunan/penambahan berat
            badan.
          </p>
          <p className="text-sm">11. Suplemen/vitamin tanpa indikasi medis.</p>
          <p className="text-sm">
            12. Perawatan di sanatorium, isolasi penyakit tertentu,
            penyalahgunaan obat/alkohol.
          </p>
          <p className="text-sm">
            13. Perawatan COVID-19 di rumah atau fasilitas non-kerja sama.
          </p>
          <p className="text-sm">
            14. Perawatan preventif (check-up, vaksinasi, desensitisasi).
          </p>
          <p className="text-sm">15. Biaya non-medis (telepon, TV, dll.).</p>
          <p className="text-sm">
            16. Gangguan mental/psikosomatik/neurologis.
          </p>
          <p className="text-sm">
            17. Rawat inap gratis (tidak dikenakan biaya).
          </p>
          <p className="text-sm">
            18. Penyakit menular seksual, operasi ganti kelamin, gangguan
            seksual, anti-aging.
          </p>
          <p className="text-sm">19. HIV/AIDS dan komplikasinya.</p>
          <p className="text-sm">20. Gangguan tidur.</p>
          <p className="text-sm">21. Paparan radiasi nuklir.</p>
          <p className="text-sm">
            22. Olahraga berisiko tinggi (balap motor/mobil, selam, panjat
            tebing, berburu, polo, olahraga musim dingin/profesional, terbang
            non-komersial).
          </p>
          <p className="text-sm">23. Sunat (kecuali indikasi medis).</p>
          <p className="text-sm">
            24. Santunan kematian tidak dibayar jika: bunuh diri {'<'} 2 tahun,
            hukuman mati, atau meninggal saat melakukan kejahatan.
          </p>
        </div>
      </>
    ),
    sumber: (
      <span className="text-blue-500 cursor-pointer" onClick={onOpenPdf}>
        policy_agreement.pdf (Halaman 4)
      </span>
    ),
  },
];
